import { useCallback, useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Spinner } from "@/components/common/Primitives";
import { ServiceFormDialog, ServiceList } from "@/components/services/ServiceParts";
import { cn } from "@/lib/utils";

const FILTERS = [["", "All"], ["overdue", "Overdue"], ["due_soon", "Due soon"], ["scheduled", "Scheduled"]];

export default function ServicesPage() {
  const { can } = useAuth();
  const [rows, setRows] = useState(null);
  const [due, setDue] = useState("");
  const [open, setOpen] = useState(false);
  const load = useCallback(() => api.get("/services", { params: due ? { due } : {} }).then((r) => setRows(r.data)), [due]);
  useEffect(() => { load(); }, [load]);
  return (
    <div>
      <PageHeader title="Services" subtitle="Service history and next-due by date or km" testId="services-header"
        actions={can("admin", "fleet_manager", "garage_supervisor") && <button onClick={() => setOpen(true)} data-testid="add-service-btn" className="flex h-10 items-center gap-1.5 rounded-full bg-primary px-4 text-sm font-semibold text-primary-foreground hover:bg-[#0071e3]"><Plus className="h-4 w-4" />Record service</button>} />
      <div className="mb-4 flex gap-1 overflow-x-auto rounded-full bg-muted p-1 w-fit" data-testid="service-due-filter">
        {FILTERS.map(([k, label]) => <button key={k} onClick={() => setDue(k)} data-testid={`service-filter-${k || "all"}`} className={cn("whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium", due === k ? "bg-card text-primary border border-border" : "text-muted-foreground")}>{label}</button>)}
      </div>
      {!rows ? <Spinner /> : <ServiceList records={rows} showVehicle />}
      <ServiceFormDialog open={open} onClose={() => setOpen(false)} onSaved={load} />
    </div>
  );
}
